import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const CommunityIconBuilder: IconBuilder = {
	icon: ({ color = '#ffffff' }) => {
		return (
			<>
				<g transform="scale(0.9) translate(51.2, 51.2)">
					<path
						d="M769.078 112c93.47 0 169.237 76.352 169.237 170.539 0 46.414-18.43 88.467-48.28 119.216 79.766 43.411 133.963 128.419 133.965 226.179v21.598c-0.003 22.65-18.226 41.011-40.701 41.014-22.478 0-40.698-18.363-40.701-41.014v-21.598c-0.003-96.568-77.704-174.856-173.536-174.856-92.064 0.003-167.349 72.262-173.126 163.568 53.072 60.526 85.293 140.054 85.293 227.174v43.165c0 22.653-18.222 41.014-40.701 41.014-22.477-0.003-40.701-18.363-40.701-41.014v-43.165c0-144.261-116.048-261.213-259.205-261.216-143.16 0-259.221 116.954-259.221 261.216v43.165c0 22.653-18.221 41.014-40.701 41.014s-40.701-18.362-40.701-41.014v-43.165c0-139.693 82.815-259.891 201.669-313.472-44.8-39.181-73.129-96.981-73.133-161.448 0-118.034 94.956-213.72 212.087-213.72 117.126 0.003 212.070 95.688 212.070 213.72-0.003 64.472-28.344 122.267-73.149 161.448 15.682 7.067 30.744 15.275 45.064 24.555 19.402-66.050 64.434-121.005 123.498-153.149-29.845-30.749-48.262-72.806-48.262-119.216 0-94.187 75.765-170.539 169.235-170.539zM340.622 237.21c-72.171 0-130.685 58.963-130.685 131.691 0.006 72.718 58.518 131.675 130.685 131.675 72.163-0.003 130.662-58.958 130.669-131.675 0-72.726-58.502-131.69-130.669-131.691zM769.078 194.029c-48.51 0-87.834 39.629-87.834 88.51 0 48.883 39.323 88.512 87.834 88.512s87.835-39.629 87.835-88.512c0-48.882-39.325-88.51-87.835-88.51z"
						fill={color}
						stroke="inherit"
					>
					</path>
				</g>
			</>
		);
	},
	viewBoxHeight: 1024,
	viewBoxWidth: 1024,
};



export default CommunityIconBuilder;

